import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { color, font, fontSize } from '../../theme'
import { UserAvatar } from '../../components/Common/UserAvatar'
import { IUser } from '../../services/api'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${color.grey};
`

interface BackgroundImageInterface {
  image?: string
}

export const BackgroundImage = styled.div<BackgroundImageInterface>`
  width: 100%;
  height: 100%;
  background-color: ${color.darkBlue};
  ${({ image }) => `background-image: url(${image});`}
  background-size: cover;
  background-position: center;
  display: flex;
  @media (max-width: 500px) {
    background-image: none;
  }
`

export const Darker = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${color.blackOpacity};
  @media (max-width: 500px) {
    background-color: ${color.darkBlue};
  }
`
export const Box = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow: hidden;
  background-color: ${color.darkBlue};
  width: 400px;
  height: 500px;
  border-radius: 5px;
  @media (max-width: 500px) {
    width: 100%;
    margin: initial;
  }
`
interface BoxHideProps {
  size: number
}
export const BoxHide = styled.div<BoxHideProps>`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 100%;
  overflow: hidden;
  transition: 0.3s ease-in-out all;
`
// margin-left: ${({ size }) => size > 400 ? -(400 - (size / 2)) : 0}px;

export const Logo = styled.img`
  margin: 20px 0;
  height: ${({ height }) => height || 60}px;
  object-fit: contain;
`

export const HideColor = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: white;
`

export const InputsContainer = styled.div`
  position: relative;
  text-align: center;
  width: 400px;
`

export const Inputs = styled.div`
  width: 350px;
  display: inline-block;
  @media (max-width: 360px) {
    width: 300px;
  }
  @media (max-width: 310px) {
    width: 270px;
  }
  @media (max-width: 280px) {
    width: 250px;
  }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid ${color.darkBlue};
  border-bottom-color: transparent;
  border-top-color: transparent;
  margin: auto;
  animation: ${rotate} 1s linear infinite;
`

export const ErrorMsg = styled.p`
  margin: 10px 0;
  color: ${color.redMain};
  font-family: ${font.sansationRegular};
  font-size: ${fontSize.medium};
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
`

interface LoggedContainerProps {
  opacity: number
}

export const LoggedContainer = styled.div<LoggedContainerProps>`
  width: 100%;
  height: 100%;
  background-color: ${color.darkBlue};
  opacity: ${({ opacity = 0 }) => opacity};
  transition: 0.3s ease-in opacity;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const LoggedAvatarContainer = styled.div`
  padding-top: 50px;
  flex: 1;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-out;
`

export const LoggedHelloText = styled.span`
  height: 50px;
  width: 100%;
  padding-bottom: 50px;
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.whiteBlue};
  font-size: ${fontSize.large};
  font-family: ${font.sansationRegular};
  text-transform: capitalize;
`

interface AnimatedLoginAvatarProps {
  user: IUser
  helloText: string
}

interface AnimatedLoginAvatarState {
  boxOpacity: number
  avatarScale: number
}

export class AnimatedLoginAvatar extends React.Component<
  AnimatedLoginAvatarProps,
  AnimatedLoginAvatarState
> {
  state = {
    avatarScale: 0,
    boxOpacity: 0,
  }

  componentDidMount() {
    setTimeout(() =>
      this.setState({ boxOpacity: 1 }, () =>
        setTimeout(() => this.setState({ avatarScale: 1 }), 200)
      )
    )
  }

  render() {
    const { boxOpacity, avatarScale } = this.state
    const { user, helloText } = this.props
    const initials = (
      user.first_name.substring(0, 1) + user.last_name.substring(0, 1)
    ).toUpperCase()
    return (
      <LoggedContainer opacity={boxOpacity}>
        <LoggedAvatarContainer style={{ transform: `scale(${avatarScale})` }}>
          <UserAvatar initials={initials} size="2xl" />
        </LoggedAvatarContainer>
        <LoggedHelloText>{helloText}</LoggedHelloText>
      </LoggedContainer>
    )
  }
}
